import React, {useCallback, useEffect} from 'react';
import {connect} from 'react-redux';
import {FilterControlsV2} from '@ey/canvascoreservices';
import { sampleItemFilterKeys } from '../../../../../../../util/uiconstants';
import {labels} from '../../../../../../../util/utils';
import Utility from '../../../../../../../util/utilityfunctions';
import * as FilterActions from '../../../../../../../actions/SampleItemFilter/filteractions';

function SampleItemFilterControls(props) {
	const {actions, filterData, userPreferences, filterConfiguration, state, dispatch, history} = props;
	const listKey = sampleItemFilterKeys.sampleItemListKey;
	let stateFilters =
		state.filters !== undefined
			? Object.values(state.filters).filter((filter) => {
					if (Utility.hasValue(filter) && Utility.hasValue(filter.name)) {
						return filter.name === listKey;
					}
					return filter;
			  })
			: state.filters;

	const handleOnClearFilters = () => {
		actions.clearFilters(filterConfiguration.key, undefined, listKey);
	};

	const handleOnDisableFilter = useCallback(
		(filter, value) => {
			actions.setFilters(filterConfiguration.key, filter, value);
		},
		[actions, filterConfiguration.key]
	);

	const setStateFilter = (filter) => {
		dispatch({
			type: 'state/set',
			value: {
				filters: filter
			}
		});
	};

	const handleSetState = useCallback(
		(callback) => {
			setStateFilter(callback(state.filters));
		},
		[state.filters, dispatch]
	);

	useEffect(() => {
		setStateFilter([]);
	}, [history]);

	return (
		<FilterControlsV2
			filterKey={filterConfiguration.key}
			state={stateFilters}
			setState={handleSetState}
			store={filterData}
			actions={actions}
			userPreferences={userPreferences}
			clearHover={labels.clearHoverText}
			clearAll={labels.sampleItemFilterLabels.clearAll}
			title={labels.sampleItemFilterLabels.filters}
			more={labels.sampleItemFilterLabels.showMore}
			onClearFilters={handleOnClearFilters}
			onDisableFilter={handleOnDisableFilter}
			theme={Utility.getTheme()}
		/>
	);
}

const mapState = (state, ownProps) => {
	return {
		filterData: state.filterData[ownProps.filterConfiguration.key],
		userPreferences: state.userPreferences
	};
};

const mapDispatch = (dispatch) => {
	return {
		actions: {
			clearFilters: (key, parentName, selectedKey) =>
				dispatch(FilterActions.clearFilters(key, parentName, selectedKey)),
			setFilters: (key, filter, value) => dispatch(FilterActions.setFilters(key, filter, value))
		}
	};
};

export default connect(mapState, mapDispatch)(SampleItemFilterControls);
